import template from '../../home-safety-solution.module.scss';
import Image from 'next/image';
import animations from '@styles/animations.module.scss'
import { InView } from 'react-intersection-observer';
import style from './results-section.module.scss'
import { IResultsItem } from '../../home-safety-solution.state';

interface TechnologiesProps {
    title: string;
    items: IResultsItem[];
}

const ResultsSection = ({ title, items }: TechnologiesProps) => {
    return (
        <section className={`${template.section}`}>
            <div className={`${template.container}`}>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <div ref={ref} className={`${animations.scroll__animation} ${template.title} ${template.title_medium} ${template.margin_bot40px} ${template.text_align_center}`}>
                                {title}
                            </div>
                        )
                    }}
                </InView>
                <div className={`${style.results__items}`}>
                    {
                        items.map((item: IResultsItem, index: number) => {
                            return (
                                <InView key={index} triggerOnce={true}>
                                    {({ inView, ref, entry }: any) => {
                                        if (inView) {
                                            entry.target.classList.add(animations.active);
                                        }
                                        return (
                                            <div ref={ref} className={`${animations.scroll__animation} ${style.results__item}`}>
                                                <div className={`${style.results__item__image} ${template.margin_bot24px}`}>
                                                    <Image src={item.icon} alt={item.iconAlt} width={'100px'} height={'100px'} />
                                                </div>
                                                <div className={`${style.results__item__title}`}>
                                                    {item.title}
                                                </div>
                                                <div className={`${style.results__item__subtitle} ${template.text} ${template.text_small}`}>
                                                    {item.text}
                                                </div>
                                            </div>
                                        )
                                    }}
                                </InView>
                            )
                        })
                    }
                </div>

            </div>
        </section>
    )
}

export default ResultsSection;
